<template>
  <div class="contact">
    <p>Contact me if you'd like to buy some prints, or have an idea for a project:</p>
    <p>
      <a href="mailto:photos@kaifuglem.com">photos@kaifuglem.com</a>
    </p>
    <hr>
    <p>Or follow me to see more of my work:</p>
    <p class="social-icons">
      <a target="_blank" href="https://instagram.com/kaizer_bun/">
        <font-awesome-icon :icon="['fab', 'instagram']" /> Instagram
      </a>
      <a target="_blank" href="https://twitter.com/kaifuglem">
        <font-awesome-icon :icon="['fab', 'twitter']" /> Twitter
      </a>
      <a target="_blank" href="https://500px.com/kaifuglem">
        <font-awesome-icon :icon="['fab', '500px']" /> 500px
      </a>
    </p>
  </div>
</template>

<script>
export default {
  name: 'Contact',
}
</script>

<style lang="scss" scoped>
$padding: 32px;

.contact {
  padding: $padding;

  p {
    margin-top: 0;
    font-size: 14px;
    line-height: 1.5;
  }

  hr {
    margin-top: $padding;
    margin-bottom: $padding;
    border: none;
    border-bottom: 1px dotted #676767;
  }

  p.social-icons a {
    display: inline-flex;
    align-items: center;
    margin-top: 20px;
    margin-right: 16px;
    cursor: pointer;
    text-transform: uppercase;
    font-size: 11px;
    letter-spacing: 2px;

    .svg-inline--fa {
      margin-right: 10px;
      font-size: 20px;
    }
  }
}
</style>
